export class FloorSelectorSeparator extends Autodesk.Viewing.UI.Button {
	/**
	 *
	 * @param id
	 * @param single Is there only one separator in the floor selector toolbar, or 2. If 2 each separator will be half the normal height
	 */
	public constructor(id: string, single: boolean) {
		super(id);

		this.icon.innerHTML = "...";
		this.addClass(`be-toolbar-separator${single ? "" : "-half"}`);
	}

	public set active(value: boolean) {
		if (value) {
			this.setState(Autodesk.Viewing.UI.Button.State.ACTIVE);
		} else {
			this.setState(Autodesk.Viewing.UI.Button.State.INACTIVE);
		}
	}
}
